import { memo } from 'react';

import { ClientsListItemData } from 'api/types/data';
import {
  TableSortProps,
  Table,
  TablePaginationProps,
  TableOnCellClick,
  TableSetRowHref,
} from 'libs/ui';

import { ClientsListItem, SortField } from '../../types';

import { useClientsTable } from './useClientsTable';

export interface ClientsTableProps
  extends TableSortProps<SortField>,
    TablePaginationProps {
  clients: ClientsListItemData[];
  loading?: boolean;
  noRowsLabel?: string;
  onCellClick?: TableOnCellClick<ClientsListItem>;
  setRowHref?: TableSetRowHref<ClientsListItem>;
}

export const ClientsTable = memo(
  ({
    clients,
    loading,
    sort,
    limit,
    rowCount,
    page,
    noRowsLabel,
    onCellClick,
    onSortChange,
    onPaginationChange,
    setRowHref,
  }: ClientsTableProps) => {
    const { columns, rows } = useClientsTable(clients);

    return (
      <Table
        columns={columns}
        limit={limit}
        loading={loading}
        noRowsLabel={noRowsLabel}
        page={page}
        rowCount={rowCount}
        rowHeight={60}
        rows={rows}
        setRowHref={setRowHref}
        sort={sort}
        onCellClick={onCellClick}
        onPaginationChange={onPaginationChange}
        onSortChange={onSortChange}
      />
    );
  }
);
